const findPaymentOption = (quote) => {
    const selectedPaymentOption = quote.paymentOptions
        .filter((paymentOption) => !paymentOption.disabled)
        .find((paymentOption) => paymentOption.payIn === 'BANK_TRANSFER');
    if (selectedPaymentOption) {
        return selectedPaymentOption;
    }
    return quote.paymentOptions[0];
};
function extractWiseQuote(quote) {
    const paymentOption = findPaymentOption(quote);
    return {
        fee: paymentOption.fee.total + paymentOption.fee.discount,
        rate: quote.rate,
        receivedAmount: paymentOption.targetAmount,
        dateCollected: new Date(),
    };
}
export default extractWiseQuote;
